module.exports = __webpack_public_path__ + "img/icon-livecasino-white.b8f57a70.svg";